import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import DocumentsAndForm from "./DocumentsAndForm";
import Messages from "./Messages";
import Contact from "./Contact";
import Help from "./Help";
import { envelopeVerifyOtp, getCustomerEnvelopeData } from "../../services/CommonService";
import Utils from "../../utils";
import CustomerPortalTab from "./CustomerPortalTab";
import { Lang } from "../../lang";
import { toast } from "react-toastify";
import { CUSTOMER_PORTAL } from "../../configs/AppConfig";
import Logo from '../../assets/Images/Docusafe_logo.webp';

function CustomerPortal(props) {
    let { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [envelopeData, setEnvelopeData] = useState({});
    const [contactData, setContactData] = useState({});
    const [theme, setTheme] = useState('');
    const [error, setError] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState(true);

    // OTP state as array
    const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef([]);

    let errorsObj = {
        password: ''
    };
    const [errors, setErrors] = useState(errorsObj);

    const openPasswordModal = useRef(null);
    const clsPasswordModal = useRef(null);

    useEffect(function () {
        document.title = Lang.client_portal_title;
        getCustomerEnvelopeData({ uuid: id })
            .then((response) => {
                setEnvelopeData(response.data.data);
                setTheme(response.data.data.theme_color);
                setContactData(response.data.data.contact_detail);
                let localStore = sessionStorage.getItem(CUSTOMER_PORTAL);
                if (localStore) {
                    if (localStore === id) {
                        setOtp(false);
                    }
                }
                setLoading(false);
            })
            .catch((err) => {
                setError(Utils.getErrorMessage(err));
                setLoading(false);
            });
    }, [id]);

    const handlePasswordForm = (e) => {
        e.preventDefault();
        let errorObj = { ...errorsObj };
        let error = false;
        if (!password) {
            errorObj.password = 'Please enter password';
            error = true;
        } else if (password !== envelopeData.password) {
            errorObj.password = 'Enter password is wrong.';
            error = true;
        }
        setErrors(errorObj);
        if (error) return;
        clsPasswordModal?.current.click();
    };

    // OTP input logic
    const handleOtpInput = (e, idx) => {
        let value = e.target.value.replace(/[^0-9]/g, '');
        if (value.length > 1) return;
        setOtpValues(prev => {
            const arr = [...prev];
            arr[idx] = value;
            return arr;
        });
        if (value && idx < 5) {
            inputRefs.current[idx + 1]?.focus();
        }
    };

    const handleOptClear = (e, idx) => {
        if (e.key === 'Backspace') {
            if (!otpValues[idx] && idx > 0) {
                inputRefs.current[idx - 1]?.focus();
            }
            setOtpValues(prev => {
                const arr = [...prev];
                arr[idx] = '';
                return arr;
            });
        }
    };

    const handlePasteValue = (e) => {
        let value = e.clipboardData.getData('text').replace(/[^0-9]/g, '');
        let length = value.length;
        if (length === 6) {
            setOtpValues(value.split(''));
            setTimeout(() => {
                inputRefs.current[5]?.focus();
            }, 0);
        }
    };

    const handleOtp = async (e) => {
        e.preventDefault();
        let otpValue = otpValues.join('');
        if (otpValue.length === 6) {
            setLoading(true);
            let ipAddress = '';
            await Utils.getIpAddress().then(response => {
                ipAddress = response;
            });
            let obj = {
                ip_address: ipAddress,
                otp: otpValue,
                id: envelopeData.id,
                recipient_id: envelopeData.recipient_detail.id,
                recipient_email: envelopeData.recipient_detail.email
            };
            envelopeVerifyOtp(obj)
                .then(response => {
                    setLoading(false);
                    setOtp(false);
                    if (envelopeData.password) {
                        setTimeout(function () {
                            openPasswordModal?.current.click();
                        }, 0);
                    }
                    sessionStorage.setItem(CUSTOMER_PORTAL, id);
                })
                .catch(err => {
                    setLoading(false);
                    toast.error(Utils.getErrorMessage(err));
                });
        } else {
            toast.error('Invalid OTP');
        }
    };

    return (
        <>
            {loading && (
                <div className="page-loading">
                    <img src="/images/loader.gif" alt="loader" />
                </div>
            )}
            <div className={`wrapper clientPortal ${theme}`}>
                <Header envelopeData={envelopeData} />
                {otp === true && (
                    <div className="section-bg-color">
                        <section
                            className="client_portal d-flex align-items-center justify-content-center"
                            style={{ minHeight: 'calc(100vh - 94px)' }}>
                            <div className="otp-box h-100">
                                <div className="otp-card bg-white rounded-1 shadow-lg p-2 p-md-5 mx-2 mx-md-0 ">
                                    <div className="text-center mb-4">
                                        <img src={Logo} alt="docusafe_logo" className="docusafe_logo" />
                                    </div>
                                    <div className="text-center mb-3">
                                        <h5 className="fw-bold mb-2">Please enter 6 digit Access Code</h5>
                                        <div className="text-muted small">received in the email</div>
                                    </div>

                                    <div className="d-flex justify-content-center gap-2 mb-4">
                                        {[0, 1, 2, 3, 4, 5].map(idx => (
                                            <input
                                                key={idx}
                                                type="number"
                                                className="otp-input"
                                                maxLength="1"
                                                value={otpValues[idx]}
                                                onPaste={handlePasteValue}
                                                ref={el => inputRefs.current[idx] = el}
                                                onKeyDown={e => {
                                                    handleOptClear(e, idx);
                                                    if (e.key === 'Enter' && otpValues.every(v => v)) {
                                                        handleOtp(e);
                                                    }
                                                }}
                                                onChange={e => handleOtpInput(e, idx)}
                                                autoFocus={idx === 0}
                                                tabIndex={idx + 1}
                                            />
                                        ))}
                                    </div>
                                    <button
                                        className="otp-btn w-100"
                                        onClick={handleOtp}
                                        disabled={loading || otpValues.some(v => !v)}
                                    >
                                        {loading ? "Verifying..." : "Verify"}
                                    </button>
                                </div>
                            </div>
                        </section>
                    </div >
                )
                }

                {
                    otp === false && (
                        <>
                            {!error &&
                                <>
                                    {!envelopeData.is_finish &&
                                        <div className=" section-bg-color">
                                            <section className="setting_tab client_portal px-3 pb-2 custom_container_portal"
                                                style={{ minHeight: "calc(100vh - 165px)", paddingTop:"20px" }}>

                                                <CustomerPortalTab envelopeData={envelopeData} />

                                                <div className="tab-content p-3 rounded-1" id="nav-tabContent"
                                                    style={{ minHeight: "calc(100vh - 280px)" }}>

                                                    <DocumentsAndForm envelopeData={envelopeData} setLoading={setLoading} />

                                                    <Messages envelopeData={envelopeData} />

                                                    <Contact contactData={contactData} />

                                                    <Help />
                                                </div>
                                            </section>

                                            <button type="button" className="btn btn-primary d-none" data-bs-toggle="modal"
                                                ref={openPasswordModal} data-bs-target="#passwordModal">
                                            </button>
                                            <div className="modal fade" id="passwordModal" tabIndex="-1"
                                                aria-labelledby="exampleModalLabel"
                                                data-bs-backdrop="static" data-bs-keyboard="true" aria-hidden="true">
                                                <div className="modal-dialog">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h1 className="modal-title fs-5" id="exampleModalLabel">Enter
                                                                Password</h1>
                                                        </div>
                                                        <div className="modal-body">
                                                            <div className="form-group">
                                                                <input type="password" className="form-control" value={password}
                                                                    onChange={(e) => setPassword(e.target.value)}
                                                                    placeholder="Enter password" />
                                                                {errors.password &&
                                                                    <div className="text-danger mt-1 ms-2">{errors.password}</div>}
                                                            </div>
                                                        </div>
                                                        <div className="modal-footer ">
                                                            <button type="button" className="btn btn-secondary d-none"
                                                                ref={clsPasswordModal} data-bs-dismiss="modal">Close
                                                            </button>
                                                            <button type="button" onClick={handlePasswordForm}
                                                                className="btn btn-primary">Submit
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {envelopeData.is_finish && <div className="error_Wrapper">
                                        <div className="card">
                                            <span className="text-success mb-3 error_icon">
                                                <i className="bi bi-check-circle-o" aria-hidden="true" />
                                            </span>
                                            <h2 className=" mb-2"><b>Completed</b></h2>
                                            {envelopeData.finish_message}
                                        </div>
                                    </div>
                                    }
                                </>
                            }

                            {error && <div className="error_Wrapper">
                                <div className="card">
                                    <span className="text-danger mb-3 error_icon">
                                        <i className="fa fa-exclamation-triangle" aria-hidden="true" />
                                    </span>
                                    <h2 className=" mb-2"><b>ERROR</b></h2>
                                    {error}
                                </div>
                            </div>
                            }

                        </>
                    )
                }
                <Footer />
            </div >
        </>
    );
}

export default CustomerPortal;
